import {Grid, IconButton, Typography} from "@mui/material";
import {Close, Document, Download} from "~/ui/icons";
import React from "react";
import {makeStyles} from "@mui/styles";
import {Box} from "@mui/system";
import {ConfirmActionDialog} from "~/components/ConfirmActionDialog";

type FileCardDefaultProps = {
    type: "download" | "upload"
    name: string
    size?: number
    format?: string
    uri?: string
    onRemove?: () => void
}

export type FileCardProps = FileCardDefaultProps & ({
    type: "download"
    uri: string
} | {
    type: "upload"
    format: string
    onRemove: () => void
})


const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: 10,
        padding: "8px 12px",
        backgroundColor: "rgba(63, 121, 181, 0.12);",
    }
}));


export const FileCard = (props: FileCardProps) => {
    const {name, size, format, uri, onRemove, type} = props;

    const classes = useStyles(props);

    const handleDownloadClick = () => {
        window.open(uri, "_blank");
    }

    return (
        <>
            <Grid container direction="row" wrap="nowrap" alignItems="center" className={classes.root}>
                <Grid item>
                    <Document color="additionalPrimary"/>
                </Grid>
                <Grid item container zeroMinWidth flexGrow={1} direction="column" wrap="nowrap" rowSpacing="2px"
                      margin="0 12px">
                    <Grid item>
                        <Typography variant="inputText2" display="block" noWrap>
                            {name}
                        </Typography>
                    </Grid>
                    {format && (
                        <Grid item>
                            <Typography variant="inputTitle2" color="secondary" display="inline-block" noWrap>
                                {format}
                                {size > 0 && (
                                    <>
                                        &nbsp;({(size / Math.pow(2, 20)).toFixed(1)}MB)
                                    </>
                                )}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
                <Grid item>
                    {type === 'download'
                        ? <IconButton onClick={handleDownloadClick}>
                            <Download color="primary"/>
                        </IconButton>
                        : <IconButton onClick={onRemove}>
                            <Close color="primary"/>
                        </IconButton>
                    }
                </Grid>
            </Grid>
        </>
    )
}
